export interface AwsApiKeys {
    apiKeyId: String,
    isActive: Boolean,
    name: String,
    description: String,
    createdByUserName: String,
    createdAt: Date|null,
    lastUsedAt: Date|null,
    apiKeyValue: String
}

const newAwsApiKey: AwsApiKeys = {
    apiKeyId: "",
    isActive: false,
    name: "",
    description: "",
    createdByUserName: "",
    createdAt: null,
    lastUsedAt: null,
    apiKeyValue: ""
}

export default { newAwsApiKey };